import { Injectable } from '@angular/core';
import { UploadImageResource } from '../resources/uploadImage.resource';

@Injectable()
export class UploadImageService {
  constructor(private readonly resource: UploadImageResource) {}

  findBy(field: string, value: string, condition = '=') {
    this.resource.clearFilters();
    this.resource.addFilter(field, condition, value);
    return this.resource.all();
  }

  all(page?) {
    this.resource.clearFilters();
    return this.resource.all(page);
  }

  get(id) {
    return this.resource.get(id);
  }

  store(data) {
    return this.resource.store(data);
  }

  update(id, data) {
    return this.resource.update(id, data);
  }

  delete(id) {
    return this.resource.delete(id);
  }

  getPagination() {
    return this.resource.getPaginationInfo();
  }
}
